import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { useWaveMuteSettings } from "./useWaveMuteSettings";
import { useWavePreferenceSettings } from "./useWavePreferenceSettings";
export function useWaveNotificationSettings(wave) {
  const $ = _c(4);
  const mute = useWaveMuteSettings(wave);
  const preferences = useWavePreferenceSettings(wave);
  const following = wave.subscribed_actions.length > 0;
  let t0;
  if ($[0] !== following || $[1] !== mute || $[2] !== preferences) {
    t0 = {
      following,
      ...mute,
      ...preferences
    };
    $[0] = following;
    $[1] = mute;
    $[2] = preferences;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
}
export type WaveNotificationSettingsState = ReturnType<typeof useWaveNotificationSettings>;